import AuthService from './services/authService'
import UserService from './services/userService'
import ShopService from './services/shopService'
import ProductService from './services/productService'
import OrderService from './services/orderService'
import PaymentService from './services/paymentService'
import ReviewService from './services/reviewService'
import NotificationService from './services/notificationService'
import AnalyticsService from './services/analyticsService'
import blogService from './services/blogService'

// اکسپورت کلی سرویس‌ها
export {
  AuthService,
  UserService,
  ShopService,
  ProductService,
  OrderService,
  PaymentService,
  ReviewService,
  NotificationService,
  AnalyticsService
}

// اکسپورت پیش‌فرض
export default {
  auth: AuthService,
  user: UserService,
  shop: ShopService,
  product: ProductService,
  order: OrderService,
  payment: PaymentService,
  review: ReviewService,
  notification: NotificationService,
  analytics: AnalyticsService,
  blog: blogService,
}